import i18n from '../translations';

export default {
  0: i18n.t('ErrorCodes.internalServerError'),
  4: i18n.t('ErrorCodes.notFound'),
  7: i18n.t('ErrorCodes.validationError'),
  42: i18n.t('ErrorCodes.rateLimitReached'),
  1001: i18n.t('ErrorCodes.tokenMissing'),
  1002: i18n.t('ErrorCodes.invalidExpiredToken'),
  1003: i18n.t('ErrorCodes.tokenDoesNotExist'),
  1004: i18n.t('ErrorCodes.userTokenDoesNotExist'),
  1005: i18n.t('ErrorCodes.refreshTokenAlreadyUsed'),
  1006: i18n.t('ErrorCodes.tokenExpired'),
  2001: i18n.t('ErrorCodes.userNotFound'),
  2002: i18n.t('ErrorCodes.userNotFoundUnauthorized'),
  2003: i18n.t('ErrorCodes.passwordNotMatching'),
  2004: i18n.t('ErrorCodes.emailUnique'),
  2005: i18n.t('ErrorCodes.approveTokenNotFound'),
  2006: i18n.t('ErrorCodes.passwordTokenNotFound'),
  2007: i18n.t('ErrorCodes.denyTokenNotFound'),
  2008: i18n.t('ErrorCodes.tokenInvalid'),
  2009: i18n.t('ErrorCodes.userPendingUpdate'),
  2010: i18n.t('ErrorCodes.userFailedCreateAccount'),
  2011: i18n.t('ErrorCodes.userNotActive'),
  2012: i18n.t('ErrorCodes.userBlocked'),
  2013: i18n.t('ErrorCodes.loginLimitReachedBlocked'),
  3004: i18n.t('ErrorCodes.sessionNotFound'),
  4001: i18n.t('ErrorCodes.confirmedAttendance'),
  4002: i18n.t('ErrorCodes.cancelWithoutConfirming'),
  4003: i18n.t('ErrorCodes.alreadyJoined'),
  4004: i18n.t('ErrorCodes.timeslotNotFound'),
  4005: i18n.t('ErrorCodes.userNotSubscribed'),
  4006: i18n.t('ErrorCodes.sessionCloseToStartTime'),
  4007: i18n.t('ErrorCodes.youCannotAttend'),
  4008: i18n.t('ErrorCodes.alreadyProvidedFeedback'),
  5001: i18n.t('ErrorCodes.userNotSubscribed'),
  5002: i18n.t('ErrorCodes.subscriptionNotActive'),
  6004: i18n.t('ErrorCodes.subscriptionNotActive'),
  8000: i18n.t('ErrorCodes.stripeErrorMessage'),
  9000: i18n.t('ErrorCodes.airtableErrorMessage'),
};
